import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-head",
  "use": "arrow-head-usage",
  "viewBox": "0 0 12 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 18\" id=\"arrow-head\">\n  <g stroke=\"none\" fill-rule=\"evenodd\">\n    <path d=\"M2.6524322,9 L11.5278765,16.7614105 L12,17.1742737 L11.0557531,18 L10.5836296,17.5871368 L1.7081852,9.82572633 L0.76393826,9 L1.2360617,8.58713683 L10.5836296,0.412863167 L11.0557531,-6.21724894e-15 L12,0.825726334 L11.5278765,1.2385895 L2.6524322,9 Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol